import { render, staticRenderFns } from "./rlabel.vue?vue&type=template&id=00740d54&"
import script from "./rlabel.vue?vue&type=script&lang=js&"
export * from "./rlabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports